export default function CsharpStudyPlan() {
  return (
    <h2>Csharp Study Plan</h2>
  );
}
